import { render } from "./EmployeeApprovalsEditApprovals.vue?vue&type=template&id=56af42d6&scoped=true"
import script from "./EmployeeApprovalsEditApprovals.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovalsEditApprovals.vue?vue&type=script&lang=js"

import "./EmployeeApprovalsEditApprovals.vue?vue&type=style&index=0&id=56af42d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56af42d6"]])

export default __exports__